import { render, staticRenderFns } from "./passportUploadComment.vue?vue&type=template&id=13ad3f74&"
import script from "./passportUploadComment.vue?vue&type=script&lang=js&"
export * from "./passportUploadComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports